<style lang="scss">
    .loading-in {
        margin-top: 20px;
        .el-upload-list__item {
            transition: none !important;
        }
        .el-upload-list {
            max-height: 35px;
            overflow: hidden;
        }
    }
</style>
<template>
    <my-dialog :show.sync="dialog.show" title="导入" @save="$refs.upload.submit()" :loading="loading">
        <div>
            <el-link type="primary" target="_blank" :href="`${publicPath}template/${file}`">模板下载</el-link>
        </div>

        <div class="loading-in">
            <el-upload ref="upload" :action="api" :with-credentials="true" :file-list="fileList" :auto-upload="false" :data="data"
                       name="file" :headers="headers" :on-change="handleChange" :on-success="success" :on-error="failed">
                导入excel数据
                <el-button size="mini" icon="el-icon-download" class="btn-blue">点击上传</el-button>
            </el-upload>
        </div>
    </my-dialog>
</template>

<script>
    export default {
        props: {
            dialog: {},
            file: {},
            api: {},
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                loading: false,
                fileList: [],
                headers: {
                    Authorization: this.$help.tokenHelp.get()
                },
                data: {
                    importKey: new Date().getTime()
                },
            }
        },
        watch: {
            'dialog.show'() {
                if (this.dialog.show) {
                    setTimeout(() => {
                        let submitFun = this.$refs.upload.submit
                        this.$refs.upload.submit = () => {
                            if (this.fileList.length === 1) {
                                this.loading = true
                                submitFun()
                            } else {
                                this.$help.error('请选择一个文件')
                            }
                        }
                    }, 1000)
                }
            },
        },
        methods: {
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-1)
            },
            success(res) {
                if (res.status === this.$variable.successCode) {
                    this.$emit('success')
                    this.loading = false
                    this.$help.success("导入成功");
                } else {
                    this.failed(res.msg)
                }
            },
            failed(msg) {
                this.$refs.upload.clearFiles()
                this.loading = false
                this.$help.error(msg)
            }
        }
    }
</script>
